const productLink = (animalRoute: string | undefined, productSlug: string | undefined, productIndex: number) => {
  return { pathname: `${animalRoute}/${productSlug}`, query: { index: productIndex } }
}

export default productLink
